export default "__VITE_ASSET__C4F_lzAi__"